// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--ncjgF","seo-text":"da51a739f7--seo-text--J5bWO"};